import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FateDropdown } from 'fate-editor';

/**Componente per la dropdown dei font */
@Component({
  selector: 'app-font',
  templateUrl: './font.component.html',
  styleUrls: ['./font.component.css']
})
export class FontComponent implements FateDropdown {
  /**Input, la stringa eventualmente selezionata */
  @Input() public value: string;

  /**Emettitore per il valore selezionato dalla dropdown */
  @Output() public valueChange = new EventEmitter<string>();

  /**
   * Metodo che gestisce l'emissione del valore selezionato
   * @param value {any} il valore selezionato
   */
  public changeValue(value) {
    this.value = value;
    this.valueChange.emit(value);
  }

  constructor() { }

  /**Metodo che gestisce la selezione del successivo */
  public selectNext () {};
  /**Metodo che gestisce la selezione del precedente */
  public selecPrevious () {};
  /**Metodo che conferma la selezione lanciando il metodo di cambio valore */
  public confirmSelection () {};
}
